// extracted by css-extract-rspack-plugin
export default {"wrapper":"CallMeBanner_wrapper__Mv38P","closeButton":"CallMeBanner_closeButton__1U7xO","accent":"CallMeBanner_accent__P7csL"};